<template>
  <div class="rew19_page_wrap">
    <button v-if="havePrev"
      @click="onPage(prevPageNo)"
      type="button" class="rew19_page__btn">
      <span class="prev-icon">이전</span>
    </button>

    <div class="rew19_page__list">
      <a v-for="(pNo) in currentPageGroup" :key="pNo"
        :class="{'rew19_page__btn--active' : pNo === currentPage}"
        class="rew19_page__btn"
        @click="onPage(pNo)"
        >{{pNo}}</a>      
    </div>

    <button v-if="haveNext"
      @click="onPage(nextPageNo)"
      type="button" class="rew19_page__btn">
      <span class="next-icon">다음</span>
    </button>    

    <!--<br/>totalPage:{{totalPage}}-->
  </div>
</template>

<script>
export default {
  name: 'PageNav',
  props: {
    totalItemCount: {
      type: Number,
      required: true
    },
    itemCountPerPage :{
      type: Number,
      required: true
    },
    pageNo: {
      type: Number,
      default: 1
    },    
    pageGroup:{
      type: Number,
      default: 5
    }
  },
  watch: {
    show(pageNo) {
      pageNo && this.$nextTick(() => {
        this.$el.focus();
      })
    }
  },
  data() {
    return {
      currentPage : this.pageNo,
      totalItem : this.totalItemCount,
      pageGroupCount : this.pageGroup,
      itemPerPage : this.itemCountPerPage,
      totalPage : 1,
      currentPageGroup : [],
      havePrev : false,
      prevPageNo : 0,
      haveNext : false,
      nextPageNo : 0,
    }
  },
  mounted() {
    let _this = this;

    _this.resetVal();
  },
  methods :{
    onPage(pageNo){
      let _this = this;

      //_this.currentPage = pageNo;

      if(_this.currentPage !== pageNo){
        _this.$emit('onClickPage', pageNo);
      }
    },

    resetVal(totalItemCount, pageNo, itemCountPerPage, pageGroup){
      let _this = this;

      _this.currentPage = pageNo ? pageNo : _this.pageNo;      
      _this.totalItem = totalItemCount ? totalItemCount : _this.totalItemCount;
      _this.itemPerPage = itemCountPerPage ? itemCountPerPage : _this.itemCountPerPage;
      _this.pageGroupCount = pageGroup ? pageGroup : _this.pageGroup;
      
      _this.calcPaging();
    },

    calcPaging(){
      var _this = this;
      
      if(_this.totalItem > 0 && _this.itemPerPage > 0){
        var mod = _this.totalItem % _this.itemPerPage;
        var quotient = (_this.totalItem - mod) / _this.itemPerPage;
        
        _this.totalPage = quotient + (mod == 0 ? 0 : 1);			
        if(_this.currentPage > _this.totalPage){
          _this.currentPage = _this.totalPage;
        }
        
      }else{
        _this.itemPerPage = 10;
        _this.currentPage = 1;
        _this.totalPage = 1;
      }
      
      var sg = Math.floor((_this.currentPage -1) / _this.pageGroupCount);

      var sIdx = sg * _this.pageGroupCount + 1;
      var eIdx = sIdx + _this.pageGroupCount - 1;

      if (eIdx > _this.totalPage)
        eIdx = _this.totalPage;

      var pgCount = eIdx - sIdx + 1;

      _this.currentPageGroup = new Array(pgCount);
      for(var i = 0; i < _this.currentPageGroup.length; ++i)
      {
        _this.currentPageGroup[i] = sIdx + i;
      }

      if(pgCount == 0){
        _this.havePrev = _this.haveNext = false;        
      }else{
        _this.havePrev = _this.currentPageGroup[0] > _this.pageGroupCount;
        _this.haveNext = _this.currentPageGroup[_this.currentPageGroup.length - 1] < _this.totalPage;
      }

      if(_this.havePrev && _this.currentPageGroup.length > 0){
        _this.prevPageNo = _this.currentPageGroup[0] -1;
      }

      if(_this.haveNext && _this.currentPageGroup.length > 0){
        _this.nextPageNo = _this.currentPageGroup[_this.currentPageGroup.length - 1] + 1;
      }
    }
  }
}
</script>
<style>
a.rew19_page__btn{
  cursor: pointer;
}
a.rew19_page__btn.rew19_page__btn--active{
  cursor: inherit;
}
</style>


// WEBPACK FOOTER //
// src/components/paging/pageNav.vue